import React, { useContext, useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useForm } from "react-hook-form";
import * as ROUTES from "../constans/rutas";
import { useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import logo from "../asses/img/ponit.png";
import imagen from "../asses/img/contacto-azul@3x.png";
import AuthContex from "../context/autenticacion/authContex";
import { persistAppUserSession } from "../config/firebaseUser";

const MODULE_PERMISSIONS = {
  "nathalia.uribe@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/EthicsChannel",
  ],
  "marcela.suarez@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/EthicsChannel",
  ],
  "diana.pineros@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/EthicsChannel",
  ],
  "darwin.quintero@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/creditNotes",
    "/EthicsChannel",
    "/Pending",
    "/boleta",
    "/invoiceSupportDoc",
    "/PDF",
    "/Facturacion",
    "/Planillas",
    "/Auditoria",
  ],
  "david.barreto@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/creditNotes",
    "/EthicsChannel",
    "/Pending",
    "/boleta",
    "/invoiceSupportDoc",
    "/PDF",
    "/Facturacion",
    "/Planillas",
    "/Auditoria",
    "/Clientes",
  ],
  "lency.camacho@parking.net.co": [
    "/Pending",
    "/boleta",
    "/PDF",
    "/Clientes",
  ],
  "elkin.barrero@parking.net.co": [
    "/Pending",
    "/boleta",
    "/invoiceSupportDoc",
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/EthicsChannel",
    "/Facturacion",
    "/Planillas",
    "/Auditoria",
  ],
  "contabilidad@parking.net.co": ["/invoiceSupportDoc"],
  "contabilidad.impuestos@parking.net.co": ["/invoiceSupportDoc"],
  "contabilidad.arriendos@parking.net.co": [
    "/invoiceSupportDoc",
    "/creditNotes",
  ],
  "claudia.daleman@parking.net.co": ["/invoiceSupportDoc"],
  "elizabeth.moncada@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/creditNotes",
    "/Pending",
    "/boleta",
    "/PDF",
    "/Planillas",
    "/Auditoria",
  ],
  "sandra.rodriguez@parking.net.co": [
    "/Desenganche",
    "/creditNotes",
    "/Mensualidades",
    "/Convenios",
    "/Pending",
    "/boleta",
    "/PDF",
    "/Planillas",
    "/Auditoria",
  ],
  "sandra.acosta@parking.net.co": [
    "/Desenganche",
    "/creditNotes",
    "/Planillas",
    "/Auditoria",
  ],
  "auxplanillasnorte@parking.net.co": ["/Planillas", "/Auditoria"],
  "claudia.guerrero@parking.net.co": ["/Desenganche"],
  default: ["/Desenganche", "/Mensualidades", "/Convenios"],
};

const normalizeEmail = (value) =>
  String(value || "")
    .toLowerCase()
    .replace(/\s+/g, "")
    .trim();

const getAccessibleRoutes = (usuario) => {
  const candidates = [usuario && usuario.email, usuario && usuario.correo]
    .map(normalizeEmail)
    .filter(Boolean);

  for (let i = 0; i < candidates.length; i += 1) {
    const email = candidates[i];
    if (MODULE_PERMISSIONS[email]) {
      return MODULE_PERMISSIONS[email];
    }
  }

  return MODULE_PERMISSIONS.default;
};

const HomePrincipalPage = () => {
  const history = useHistory();
  const authContex = useContext(AuthContex);
  const { usuario, usuarioAutenticado, cerrarSesion } = authContex;

  const [loading, setLoading] = useState(true);
  const [accessibleRoutes, setAccessibleRoutes] = useState([]);

  useEffect(() => {
    if (!usuario) {
      usuarioAutenticado();
    } else {
      persistAppUserSession(usuario);
      setAccessibleRoutes(getAccessibleRoutes(usuario));
      setLoading(false);
    }
  }, [usuario, usuarioAutenticado]);

  if (loading) {
    return <div className="container-sniper"></div>;
  }

  if (!usuario) {
    return <div className="container-sniper"></div>;
  }

  return (
    <>
      <div className="conntent">
        <div className="conntent_">
          <Row>
            <Col className="ContModulos" xs={12} sm={12} md={6} lg={6} xl={6}>
              <h1 className="texto-titulo">{usuario.nombre}</h1>

              <img src={logo} alt="Logo" />

              {accessibleRoutes.includes("/Desenganche") && (
                <button
                  onClick={() => history.push("/Desenganche")}
                  className="buttom"
                >
                  Desenganche
                </button>
              )}
              {accessibleRoutes.includes("/PDF") && (
                <button onClick={() => history.push("/PDF")} className="buttom">
                  Factura Electrónica
                </button>
              )}

              {accessibleRoutes.includes("/creditNotes") && (
                <button
                  onClick={() => history.push("/creditNotes")}
                  className="buttom"
                >
                  Nota Crédito
                </button>
              )}

              {accessibleRoutes.includes("/Mensualidades") && (
                <button
                  onClick={() => history.push("/Mensualidades")}
                  className="buttom"
                >
                  Mensualidades
                </button>
              )}

              {accessibleRoutes.includes("/Convenios") && (
                <button
                  onClick={() => history.push("/Convenios")}
                  className="buttom"
                >
                  Convenios
                </button>
              )}

              {accessibleRoutes.includes("/Facturacion") && (
                <button
                  onClick={() => history.push("/Facturacion")}
                  className="buttom"
                >
                  Facturacion
                </button>
              )}

              {accessibleRoutes.includes("/Clientes") && (
                <button
                  onClick={() => history.push("/Clientes")}
                  className="buttom"
                >
                  Clientes
                </button>
              )}

              {accessibleRoutes.includes("/Planillas") && (
                <button
                  onClick={() => history.push("/Planillas")}
                  className="buttom"
                >
                  Planillas
                </button>
              )}

              {accessibleRoutes.includes("/Pending") && (
                <button
                  onClick={() => history.push("/Pending")}
                  className="buttom"
                >
                  Facturas Juridicas
                </button>
              )}

              {accessibleRoutes.includes("/boleta") && (
                <button
                  onClick={() => history.push("/boleta")}
                  className="buttom"
                >
                  Facturas Punto Servicio
                </button>
              )}

              {accessibleRoutes.includes("/invoiceSupportDoc") && (
                <button
                  onClick={() => history.push("/supportdoc")}
                  className="buttom"
                >
                  Facturas Documento Soporte
                </button>
              )}

              {accessibleRoutes.includes("/EthicsChannel") && (
                <button
                  onClick={() => history.push("/EthicsChannel")}
                  className="buttom"
                >
                  Canal de etica
                </button>
              )}
            </Col>
            <Col className="ContImagen" xs={12} sm={12} md={6} lg={6} xl={6}>
              <img className="imagen" src={imagen} alt="Centro de Apoyo" />
              <h1>Centro de Apoyo</h1>
              <div>
                <Button
                  style={{ marginRight: "10px" }}
                  variant="primary"
                  onClick={() => history.push(ROUTES.REGISTRO)}
                >
                  Crear Usuario
                </Button>
                <Button variant="primary" onClick={() => cerrarSesion()}>
                  cerrar sesion
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default HomePrincipalPage;
